<template>
<Card ref="card"  :bordered="false" :padding="0" dis-hover>
    <template v-if="myConfig.modetype === '1'">
        <p  v-if="showTitle" @click="toggle" style="cursor:pointer;" >
        <Row type="flex" justify="start" align="middle" style="margin-top:14px;margin-bottom:14px">
            <CommonIcon type='_custom-pack' v-show="showGrid" size="14"/>  <CommonIcon  v-show="!showGrid" type='_custom-spread' size="14"/> <span style="margin-left:10px;font-size: 14px;font-weight:bold" v-text="myConfig.title" />
        </Row>
        </p>
        <div style="padding-left:24px">
            <Divider style="margin-top:0px;margin-bottom:10px;"/>
            <Row v-show="showGrid" type="flex" justify="start"  align="middle" :gutter="0"  style="margin-bottom: 10px;">
                <Col v-if="showAddBtn">
                    <Button  style="padding-left:0px;padding-right:0px" customIcon="iconfont icon-custom-rowadd3"  type="text"  :disabled="myConfig.readOnly" @click="addRow" >添加</Button>
                </Col>
                    <Col v-if="showAddBtn">
                        <Divider type="vertical"  style="margin: 0 6px 0 6px;height: 20px"/>
                    </Col>
                <Col v-if="showDelBatchBtn">
                    <Button  style="padding-left:0px;padding-right:0px" customIcon="iconfont icon-custom-rowdel3"  type="text" :disabled="myConfig.readOnly" @click="delBatchRow">删除</Button>
                </Col>
            </Row>
            <Row v-show="showGrid" style="border：1px solid #dcdee2">
                <Table ref="table"  :row-class-name="rowClassName" :loading="loading" :size="myConfig.tableSize"  :stripe="myConfig.showStripe"  :border="myConfig.showBorder" :height="tableHeight" :maxHeight="tableMaxHeight" :show-header="myConfig.showHeader" @on-selection-change="OnSelectionChange" :columns="tableColumns"  :data="data" @on-column-width-resize="onColumnWidthResize">
                    <template v-for="config in soltTableColumns" slot-scope="{ row, index }" :slot="config.key">
                        <div @click="EditCell(index,config)" :class="config.cellClassName">
                            <ControlBox v-if="editIndex === index && editKey=== config.key"   :autofocus="true" :config="getCellConfig(index,config)"  :valueData="getCurRow(index)" @input="input" @doAction="doAction"></ControlBox>
                            <ShowText v-else  :label="formatValue(index,config)"  :contentAlign="config.contentAlign"  :class="IsCellError(index,config)"></ShowText>
                        </div>
                    </template>
                </Table>
                <div  ref="page" v-if="myConfig.showPage" style="background:#eee;padding-top:5px;width:100%" >
                    <Card :bordered="false" :padding="0" :dis-hover="true" style="border-radius:0px">
                        <Row  type="flex" justify="end" style="padding:5px;padding-right:10px">
                            <Page  :total="myConfig.pageConfig.total_results"  :size="myConfig.pageSize"  :current="myConfig.pageConfig.page_no" :page-size="myConfig.pageConfig.page_size" :page-size-opts="myConfig.pageConfig.pageSizeList"  @on-page-size-change="changePageSize" @on-change="changePage"  :show-total="myConfig.pageShowTotal" :show-elevator="myConfig.pageShowElevator" :show-sizer="myConfig.pageShowSizer"></Page>
                        </Row>
                    </Card>
                </div>
            </Row>
        </div>
    </template>
    <template v-if="myConfig.modetype === '2'">
         <p v-if="showTitle" style="border-left: 4px solid #AF292E;padding-left:10px;margin-bottom:10px">
                <span style="font-size: 14px;font-weight:bold" v-text="myConfig.title" />
        </p>
          <Row v-show="showGrid" type="flex" justify="start"  align="middle" :gutter="0">
            <Col v-if="showAddBtn">
                <Button  customIcon="iconfont icon-custom-rowadd3"  type="text"  :disabled="myConfig.readOnly" @click="addRow" >添加</Button>
            </Col>
             <Col v-if="showAddBtn">
                 <Divider type="vertical"  style="margin: 0 6px 0 6px;height: 20px"/>
             </Col>
            <Col v-if="showDelBatchBtn">
                <Button customIcon="iconfont icon-custom-rowdel3"  type="text" :disabled="myConfig.readOnly" @click="delBatchRow">删除</Button>
            </Col>
    </Row>
    <Row v-show="showGrid" style="border：1px solid #dcdee2;margin-top: 10px;">
        <Table ref="table"  :row-class-name="rowClassName" :loading="loading" :size="myConfig.tableSize"  :stripe="myConfig.showStripe"  :border="myConfig.showBorder" :height="tableHeight" :maxHeight="tableMaxHeight" :show-header="myConfig.showHeader" @on-selection-change="OnSelectionChange" :columns="tableColumns"  :data="data" @on-column-width-resize="onColumnWidthResize">
            <template v-for="config in soltTableColumns" slot-scope="{ row, index }" :slot="config.key">
                <div @click="EditCell(index,config)"  :class="config.cellClassName">
                    <ControlBox v-if="editIndex === index && editKey=== config.key"   :autofocus="true" :config="getCellConfig(index,config)"  :valueData="getCurRow(index)" @input="input" @doAction="doAction"></ControlBox>
                    <ShowText v-else :label="formatValue(index,config)"  :contentAlign="config.contentAlign"  :class="IsCellError(index,config)"></ShowText>
                </div>
            </template>
        </Table>
        <div  ref="page" v-if="myConfig.showPage" style="background:#eee;padding-top:5px;width:100%" >
            <Card :bordered="false" :padding="0" :dis-hover="true" style="border-radius:0px">
                <Row  type="flex" justify="end" style="padding:5px;padding-right:10px">
                    <Page  :total="myConfig.pageConfig.total_results"  :size="myConfig.pageSize"  :current="myConfig.pageConfig.page_no" :page-size="myConfig.pageConfig.page_size" :page-size-opts="myConfig.pageConfig.pageSizeList"  @on-page-size-change="changePageSize" @on-change="changePage"  :show-total="myConfig.pageShowTotal" :show-elevator="myConfig.pageShowElevator" :show-sizer="myConfig.pageShowSizer"></Page>
                </Row>
            </Card>
        </div>
    </Row>
    </template> 
    <template v-if="myConfig.modetype === '3'">
        <Row  style="border：1px solid #dcdee2;margin-top: 10px;">
        <Table ref="table"  :row-class-name="rowClassName" :loading="loading" :size="myConfig.tableSize"  :stripe="myConfig.showStripe"  :border="myConfig.showBorder" :height="tableHeight" :maxHeight="tableMaxHeight" :show-header="myConfig.showHeader" @on-selection-change="OnSelectionChange" :columns="tableColumns"  :data="data" @on-column-width-resize="onColumnWidthResize">
            <template v-for="config in soltTableColumns" slot-scope="{ row, index }" :slot="config.key">
                <div @click="EditCell(index,config)"  :class="config.cellClassName">
                    <ControlBox v-if="editIndex === index && editKey=== config.key"   :autofocus="true" :config="getCellConfig(index,config)"  :valueData="getCurRow(index)" @input="input" @doAction="doAction"></ControlBox>
                    <ShowText v-else :label="formatValue(index,config)"  :contentAlign="config.contentAlign"  :class="IsCellError(index,config)"></ShowText>
                </div>
            </template>
        </Table>
        <div  ref="page" v-if="myConfig.showPage" style="background:#eee;padding-top:5px;width:100%" >
            <Card :bordered="false" :padding="0" :dis-hover="true" style="border-radius:0px">
                <Row  type="flex" justify="end" style="padding:5px;padding-right:10px">
                    <Page  :total="myConfig.pageConfig.total_results"  :size="myConfig.pageSize"  :current="myConfig.pageConfig.page_no" :page-size="myConfig.pageConfig.page_size" :page-size-opts="myConfig.pageConfig.pageSizeList"  @on-page-size-change="changePageSize" @on-change="changePage"  :show-total="myConfig.pageShowTotal" :show-elevator="myConfig.pageShowElevator" :show-sizer="myConfig.pageShowSizer"></Page>
                </Row>
            </Card>
        </div>
    </Row>
   </template> 
    <Modal v-if="!editRowFlag"  v-model="showEditRowForm"  width="90%" title="编辑" @on-ok="editRow">
        <div>
           <ExpandRow ref="rowForm"  :config="myConfig" :dictData="dictData"/>
        </div>
    </Modal>
</div>
</Card>
</template>
<script>
import Base from '@/components/grid/editgrid.vue';
export default {
    name: 'editgridcard',
    extends: Base,
    data () {
        return {
            myConfig:{
                title:'',
                operFixedFlag:false,
                showCheckBox:true
            },
            showAddBtn:true,
            showDelBatchBtn:true,
            showGrid:true,
            showTitle:true

        };
    },
    methods: {
        customInit2() {
            if (this.myConfig.showTitle !== undefined) {
                this.showTitle = this.myConfig.showTitle;
            }
        },
        toggle () {
            this.showGrid = !this.showGrid;
        },
        setShowGrid(value) {
            this.showGrid = value;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/masterplate/editgridcard.vue